<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import { home } from '@/routes';

defineProps<{
    title?: string;
    description?: string;
}>();
</script>

<template>
    <div
        class="flex min-h-svh flex-col items-center justify-center gap-6 bg-background p-6 md:p-10"
    >
        <div class="w-full max-w-md">
            <div class="flex flex-col gap-8">
                <div class="flex flex-col items-center gap-4">
                    <Link
                        :href="home()"
                        class="flex shrink-0 items-center gap-2 font-semibold text-foreground"
                    >
                        <img
                            src="/logo/light.png"
                            alt="KwikTalk"
                            class="block h-8 w-auto dark:hidden"
                        />
                        <img
                            src="/logo/dark.png"
                            alt="KwikTalk"
                            class="hidden h-8 w-auto dark:block"
                        />
                    </Link>
                    <div class="space-y-2 text-center">
                        <h1 class="text-xl font-medium">{{ title }}</h1>
                        <p class="text-center text-sm text-muted-foreground">
                            {{ description }}
                        </p>
                    </div>
                </div>
                <slot />
            </div>
        </div>
    </div>
</template>
